/*
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-08-01 22:07:45
 */

import { useCallback } from "react";
import { useAtomCallback } from "jotai/utils";
import omit from "lodash-es/omit";

import { JotaiStore } from "@/frameworks/libraries/commons";
import { Configure, Properties } from "@/frameworks/libraries";

import PhoneCallAtoms from "../PhoneCallAtoms";

export default function usePopupAPI() {
	const show = useAtomCallback(
		useCallback((get, set, options: PushServices.Call.PhoneCallPortalItem) => {
			const callList = get(PhoneCallAtoms.CallList);
			if (callList && Object.keys(callList).includes(options.callID)) {
				//check my account are calling on other devices
				const callUsers = Object.values(callList)[0].callUsers;
				const myCall = Object.values(callUsers).find((user) => user.userId === Configure.userID);
				if (myCall && myCall.status === "ACCEPTED" && Properties.browserTabID !== myCall.deviceKey) return;

				set(PhoneCallAtoms.Popup, (prev) => ({ ...prev, [options.callID]: options }));
			}
		}, []),
		{ store: JotaiStore }
	);

	const hide = useAtomCallback(
		useCallback((_, set, callID: string) => {
			set(PhoneCallAtoms.Popup, (prev) => omit(prev, callID));
		}, []),
		{ store: JotaiStore }
	);

	const info = useAtomCallback(
		useCallback((get, _, callID: string) => {
			return get(PhoneCallAtoms.Popup)[callID];
		}, []),
		{ store: JotaiStore }
	);

	return {
		show,
		hide,
		info
	};
}
